import React from 'react';

export const Navbar = () => {
  return (
    <nav className="page-header-navbar">
      <ul className="navbar-link-list">
        <li className="navbar-link">
          <a href="#content">Про мене</a>
        </li>
        <li className="navbar-link">
          <a href="#services-prices">Ціни{'&'}послуги</a>
        </li>
        <li className="navbar-link">
          <a href="#video">Блог</a>
        </li>
        <li className="navbar-link">
          <a href="#footer">Контакти</a>
        </li>
      </ul>
    </nav>
  );
};

//services-prices
